<template>
  <v-layout v-if="authStore.isLoggedIn" :dir="$root.$i18n.locale == 'ar' ? 'rtl' : 'ltr'" :full-height="true"
    class="rounded rounded-md">

    
    
    
    <v-main class="tw-min-h-screen tw-h-fit tw-overflow-y-auto tw-bg-primary-50">
      <div class="tw-w-full">
        <CompanyHeader />
      </div>

      <div class="tw-grid tw-grid-cols-12 tw-mx-auto tw-max-w-screen-2xl tw-w-full tw-mt-5 tw-gap-4 tw-px-4">
        <div class="tw-w-full tw-hidden lg:tw-block tw-col-span-12 lg:tw-col-span-3">
          <div >
            <CompanyNavigation/>
          </div>
        </div>

        <div class="tw-max-w-screen-2xl tw-mx-auto tw-w-full tw-pb-10 tw-col-span-12 lg:tw-col-span-9">
          <router-view></router-view>
        </div>
      </div>
    </v-main>
  </v-layout>
</template>

<script setup>
import { useAuthStore } from "@/stores";
import CompanyHeader from "./partials/CompanyHeader.vue";
import CompanyNavigation from "./partials/CompanyNavigation.vue";

const authStore = useAuthStore();
</script>

<style>

</style>